export default __webpack_public_path__ + "static/media/DjangoLogo.1050f69e.svg";